import { Component, HostListener, Inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { Verify2FAComponent } from 'src/app/shared/components/verify-2fa/verify-2fa.component';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { LoginService } from '../login.service';
@Component({
  standalone: true,
  selector: 'register-agree',
  templateUrl: './register-agree.component.html',
  styleUrls: ['./register-agree.component.scss'],
  imports: [CSButtonComponent, CSIconButtonComponent, FormsModule],
})
export class RegisterAgreeComponent {
  constructor(
    public dialogRef: MatDialogRef<Verify2FAComponent, boolean>,
    public loginService: LoginService,
    private localeService: LocaleService,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      callback: () => void;
      closeAfterSubmit?: boolean;
    },
  ) {
    if (data) {
      if (data?.callback !== undefined) {
        this.callback = data.callback;
      }
      if (data?.closeAfterSubmit !== undefined) {
        this.closeAfterSubmit = data.closeAfterSubmit;
      }
    }
    // 禁止點擊背景關閉對話框
    this.dialogRef.disableClose = true;
  }

  @Input()
  public callback: () => void = () => {};

  @Input()
  public closeAfterSubmit: boolean = false;

  public checkedOld: boolean = false;

  public checkedTerms: boolean = false;

  @HostListener('document:keydown.enter', ['$event'])
  public onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.checkedOld && this.checkedTerms) {
      this.submit();
    }
  }

  /**
   * 跳转服务条款
   *
   * @param e
   */
  jumpToAgree(e: any) {
    e.preventDefault();
    e.stopPropagation();
    const url = this.appService.termsConditionsLink;
    url && window.open(`${window.location.origin}/${this.appService.languageCode}${url}`, '_blank');
  }

  jumpToPolicy(e: any) {
    e.preventDefault();
    e.stopPropagation();
    const url = this.appService.privacyPolicyLink;
    url && window.open(`${window.location.origin}/${this.appService.languageCode}${url}`, '_blank');
  }

  submit(): void {
    if (this.callback) {
      this.callback();
    }

    if (this.closeAfterSubmit) {
      this.dialogRef.close(true);
    }
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
